import React from "react";
import { useHistory } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { dashboardStyles } from "../../../assets/MUIStyles/dashboard";
import BaseButton from "../Common/Buttons/BaseButton";

const SummaryCard = ({
  title,
  value,
  circleColor,
  errorMessage = false,
  expiryTime = 0,
  topupButtonShow = false,
}) => {
  const history = useHistory();
  let expired = false;
  const diffInMs = expiryTime - Date.now();
  const ceiledDiffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

  let daysLeftText = "";
  if (diffInMs > 0) {
    if (ceiledDiffInDays > 1) {
      daysLeftText = `${ceiledDiffInDays} day${
        ceiledDiffInDays > 1 ? "s" : ""
      } left`;
    } else if (ceiledDiffInDays > 0) {
      daysLeftText = "Expires today";
    }
  } else {
    expired = true;
  }

  return (
    <Box
      sx={{
        ...dashboardStyles.summaryCardContainer,
        border: errorMessage ? "1px solid red" : "1px solid #D1D9EF",
      }}
    >
      {errorMessage && (
        <div
          title="Your Account Balance is Expired. Please top up your account."
          className="card-error-cont"
        >
          <span className="card-error-text">Account Balance Expired</span>
        </div>
      )}

      {expiryTime !== 0 && expired && (
        <div title="Your Account is Expired" className="card-error-cont">
          <span className="card-error-text">Account Expired</span>
        </div>
      )}

      {expiryTime > 0 && ceiledDiffInDays > 0 && ceiledDiffInDays <= 5 && (
        <div
          title="Your Account Balance is about to expire."
          className={
            ceiledDiffInDays < 3
              ? "card-error-cont"
              : "card-error-cont card-warning"
          }
        >
          <span className="card-error-text">{daysLeftText}</span>
        </div>
      )}

      <Box className="flex-align-center" marginBottom={1}>
        <Box
          sx={{
            ...dashboardStyles.summaryCard.summaryIndicator,
            background: circleColor,
          }}
        />
        <Typography className="font-14-lightgrey">{title}</Typography>
      </Box>
      <Box className={topupButtonShow ? "flex-between" : "flex-end"}>
        {topupButtonShow && (
          <BaseButton
            variant="contained"
            title="Topup"
            handleClick={() => history.push(`/account/payments`)}
            styles={{ paddingX: 1, paddingY: 0.25, minWidth: "auto" }}
          />
        )}
        <Typography className="font-16-700-grey">{value}</Typography>
      </Box>
    </Box>
  );
};

export default SummaryCard;
